import { render, staticRenderFns } from "./baxq.vue?vue&type=template&id=35706193&scoped=true&"
import script from "./baxq.vue?vue&type=script&lang=js&"
export * from "./baxq.vue?vue&type=script&lang=js&"
import style0 from "./baxq.vue?vue&type=style&index=0&id=35706193&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35706193",
  null
  
)

export default component.exports